import { Grid, IconButton, TextField, Typography } from '@mui/material';
import FunctionsIcon from '@mui/icons-material/Functions';
import { ChangeEvent, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { toPriceString } from '../../utils';
import { calculateCalculation, setBasePrice } from './redux/calculationSlices';
import SelectArticle from './SelectArticle';
type OwnProps = {
    pricelistId: number;
};
const mapStateToProps = (state: RootState, { pricelistId }: OwnProps) => ({
    basePrice: state.calculation.basePrice,
    pricelistId: pricelistId,
    selectedProduct: state.calculation.selectedProduct,
    executedCalculationResult: state.calculation.executedCalculationResult
});
type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ExecuteCalculation = ({
    basePrice,
    pricelistId,
    selectedProduct,
    executedCalculationResult
}: Props) => {
    const dispatch = useDispatch();
    const updatePrice = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            dispatch(setBasePrice(Number(event.target.value.replace(',', '.'))));
        },
        [dispatch]
    );

    return (
        <div>
            <Grid container direction="column" justifyContent="flex-start" spacing={2}>
                <Grid item>
                    <TextField
                        onChange={e => {
                            updatePrice(e as ChangeEvent<HTMLInputElement>);
                        }}
                    />
                    <IconButton
                        disabled={basePrice === 0 || selectedProduct == null}
                        onClick={() =>
                            dispatch(
                                calculateCalculation.request({
                                    pricelistId,
                                    basePrice: basePrice,
                                    productId: selectedProduct!.productId!
                                })
                            )
                        }
                    >
                        <FunctionsIcon />
                    </IconButton>
                </Grid>

                <Grid item>
                    <SelectArticle />
                </Grid>
                <Grid item>
                    <Typography variant="body2" gutterBottom>
                        <strong>Result: </strong> {toPriceString(executedCalculationResult?.price)}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

export default connect(mapStateToProps)(ExecuteCalculation);
